/**
 * @description 把转译字符串转为html
 * @function unescapeHTML
 * @param {String} str 字符串
 * @return {String} 处理完成后的字符串
 */
export const unescapeHTML = str => {
  str = '' + str;
  return str
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'");
};
/**
 * @description 获取url参数
 * @function getRequest
 * @param {Boolean} decode 是否解码
 * @return {Array}
 */
export const getRequest = decode => {
  let ifDecode = true;
  if (decode === false) {
    ifDecode = false;
  }
  let url = location.search;
  let theRequest = {};
  if (url && url.length && url.indexOf('?') > -1) {
    let str = url.substr(1);
    let strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      if (ifDecode) {
        theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
      } else {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
    }
  }
  return theRequest;
};
/**
 * @description 将内容按照文字或者单词分割成数组
 * @function wordArr
 * @param {String} str 需要处理的字符串
 * @return {Array} 分割后的结果
 */
export const wordArr = str => {
  if (str) {
    return str.match(/[\u4e00-\u9fa5]|[A-Za-z-]+|\S/g) || [];
  } else {
    return [];
  }
};
/**
 * @description 计算单词数量
 * @function wordLength
 * @param {String} str 文本
 * @return {Number} 单词数量
 */
export const wordLength = str => {
  return wordArr(str)?.length;
};
/**
 * @func isRegExp 是否正则表达式
 * @param {String} value 字符串
 * @return {Boolean}
 */
export const isRegExp = value => {
  if (typeof value === 'string') {
    return Object.prototype.toString.call(value) === '[object RegExp]';
  } else if (typeof value === 'object') {
    return eval(value) instanceof RegExp;
  } else {
    return false;
  }
};
export const formatNumberWithCommas = num => {
  return num.toLocaleString('en-US');
};
